import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function EditorialPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 md:pt-28">
        <div className="w-full px-4 md:px-8 lg:px-12 max-w-3xl mx-auto pb-20">
          <nav className="flex items-center gap-2 text-sm mb-8">
            <a href="/" className="text-warm-500 hover:text-brand-600 transition-colors">Home</a>
            <i className="ri-arrow-right-s-line text-warm-400 text-xs" />
            <span className="text-warm-700">Editorial Policy</span>
          </nav>

          <h1 className="font-heading text-3xl md:text-4xl font-bold text-warm-900 mb-6">
            Editorial Policy
          </h1>

          <div className="text-sm md:text-base text-warm-600 leading-relaxed space-y-4">
            <p><strong>Last Updated:</strong> 2026-08-26</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">1. Independence</h2>
            <p>CSSSpreadsheetBR is an independent resource. We do not accept payment from CSSBuy or any shopping agent to promote their services. Our content is created based on research, user questions, and publicly available information.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">2. Accuracy and Updates</h2>
            <p>We strive to provide accurate and up-to-date information. However, shipping policies, coupon terms, and platform features change frequently. Each article includes a "Last Updated" date. We review and update content periodically, especially for time-sensitive topics like shipping costs and coupons.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">3. No Fabricated Information</h2>
            <p>We do not invent prices, ratings, statistics, or coupon codes. We do not publish fake reviews. When information is uncertain or based on user reports, we clearly state it as such.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">4. Source Policy</h2>
            <p>Our content is based on: official platform documentation, community discussions, user experiences, and direct research. We do not copy content from competitors. All articles are original and written for our audience.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">5. Corrections</h2>
            <p>If you find an error or outdated information, please contact us. We will review and correct factual errors promptly. Corrections will be noted in the article when significant.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">6. Affiliate Disclosure</h2>
            <p>This website does not currently use affiliate links. If this changes in the future, we will clearly disclose any affiliate relationships on the relevant pages.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}